import { useTranslation } from 'react-i18next';

import type { ui } from '@procuros/datachecks';
import type { SuccessfulEnrichment } from 'hooks/useGruAgent/types';

import { EnrichmentActionDetails } from 'components/WebEDI/EnrichmentActionDetails/EnrichmentActionDetails';

type AgentSuggestionSidebarProps = {
  agentProposal: SuccessfulEnrichment;
  uiConfig: Array<ui.Section> | undefined;
  canonical: Record<string, unknown> | undefined | null;
};

export const AgentSuggestionSidebar = ({ agentProposal, uiConfig, canonical }: AgentSuggestionSidebarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-90 shrink-0 flex-col gap-3 overflow-y-auto border-l border-gray-200 bg-white p-4">
      <p className="text-sm leading-5 font-normal text-gray-900">{t('webedi:sidebar.agents.intro')}</p>
      <EnrichmentActionDetails agentProposal={agentProposal} uiConfig={uiConfig} canonical={canonical} />
    </div>
  );
};
